import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://b1663adbe202fa3728874cdeb480340b@o1301805.ingest.sentry.io/4506304198279168",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});